// main pages
export const PAGE_HOME = "PAGE_HOME";
export const PAGE_RESEARCH = "PAGE_RESEARCH";
export const PAGE_ENGINEERING = "PAGE_ENGINEERING";
export const PAGE_SIMULATION = "PAGE_SIMULATION";
export const PAGE_OUTPUTS = "PAGE_OUTPUTS";
export const PAGE_BUILD = "PAGE_BUILD";
export const PAGE_JOURNAL = "PAGE_JOURNAL";
